var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.8495 16.0625L12.7495 11.9625L8.8495 7.76251C8.4495 7.26251 8.4495 6.56251 8.8495 6.16251C9.3495 5.76251 10.0495 5.76251 10.4495 6.16251L15.1495 11.1625C15.5495 11.5625 15.5495 12.2625 15.1495 12.7625L10.4495 17.7625C10.0495 18.2625 9.2495 18.2625 8.8495 17.7625C8.4495 17.2625 8.4495 16.5625 8.8495 16.0625Z","fill":"currentColor"}));
}

ChevronRight.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
